import { style } from '@/components/base';

const promoNoticeStyle = style(`
  .container {
    padding: 32px 24px 24px 24px;
    background: #fff;
    border: 1px solid #bdbdbd;
    border-radius: 8px;
    box-sizing: border-box;
    font-family: 'Inter', Arial, sans-serif;
    max-width: 600px;
    position: fixed;
    left: 0;
    right: 0;
    top: 50%;
    bottom: auto;
    margin: 0 auto;
    z-index: 1000;
    visibility: hidden;
    opacity: 0;
    transition: transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s cubic-bezier(0.4,0,0.2,1);
    transform: translateY(100%);
  }

  .handle {
    width: 52px;
    height: 6px;
    background: #E0E0E0;
    border-radius: 3px;
    margin: 0 auto 20px auto;
    display: block;
  }

  .title {
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    color: #191919;
    margin-bottom: 20px;
  }

  .msg {
    font-size: 1.1rem;
    color: #212121;
    margin-bottom: 32px;
    text-align: center;
  }

  .actions {
    display: flex;
    gap: 24px;
    justify-content: center;
  }

  .button {
    padding: 16px 24px;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    min-width: 180px;
    transition: background 0.2s;
  }

  .continue {
    background: #F5F5F5;
    color: #191919;
    border: 1px solid #E0E0E0;
  }

  .continue:hover {
    background: #e0e0e0;
  }

  .view {
    background: #191919;
    color: #fff;
  }

  .view:hover {
    background: #333;
  }

  @media (max-width: 500px) {
    .container {
      max-width: 100vw;
      padding: 16px 8px 12px 8px;
      position: fixed;
      left: 0;
      right: 0;
      top: 50%;
      bottom: auto;
      margin: 0 auto;
      z-index: 1000;
      transform: translateY(100%);
    }

    .actions {
      flex-direction: column;
      gap: 12px;
    }

    .button {
      min-width: 100px;
      width: 100%;
    }
  }
`);

export default promoNoticeStyle;
